import { createContext } from 'react';

export type UpdateGlobalPaymentsCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  UpdateError: string;
};

const UpdateGlobalPayments = createContext<UpdateGlobalPaymentsCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  UpdateError: '',
});

export default UpdateGlobalPayments;
